module.directive("disableRightClick", function() {
	return {
		restict : 'A',
		link : function(scope, el) {
			el.bind("contextmenu", function(e) {
				e.preventDefault();
			});
		}
	};
});